import { render, staticRenderFns } from "./FavoriteReportButton.vue?vue&type=template&id=6beb5ced&scoped=true&"
import script from "./FavoriteReportButton.vue?vue&type=script&lang=js&"
export * from "./FavoriteReportButton.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteReportButton.vue?vue&type=style&index=0&id=6beb5ced&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beb5ced",
  null
  
)

export default component.exports